import React from "react";
import { Box, Stack } from "@chakra-ui/react";

const TOP_BAR_BLUE = "#00005f";

/**
 * Horizontal scroller for pool cards in the game lobbies.
 *
 * Mirrors the game carousel on the home page: from the `sm` breakpoint up, cards
 * keep a fixed width and the row scrolls sideways instead of wrapping to two
 * columns and scrolling down. Below `sm` the cards stack vertically.
 *
 * Card widths are applied to direct children so each lobby keeps its own card
 * markup unchanged. Extra props land on the outer box — lobbies that already
 * render a separate mobile list pass display={{ base: "none", sm: "block" }}.
 */
export default function PoolCardScroller({ children, cardWidth = "260px", ...rest }) {
  return (
    <Box
      overflowX={{ base: "visible", sm: "auto" }}
      pb={{ base: 0, sm: 2 }}
      sx={{
        "&::-webkit-scrollbar": { height: "10px" },
        "&::-webkit-scrollbar-track": {
          background: "rgba(0,0,0,0.06)",
          borderRadius: "8px",
        },
        "&::-webkit-scrollbar-thumb": {
          background: `${TOP_BAR_BLUE}66`,
          borderRadius: "8px",
        },
        "&::-webkit-scrollbar-thumb:hover": { background: `${TOP_BAR_BLUE}99` },
      }}
      {...rest}
    >
      <Stack
        direction={{ base: "column", sm: "row" }}
        spacing={4}
        align="stretch"
        minW={{ base: "auto", sm: "max-content" }}
        sx={{
          "& > *": {
            flexShrink: 0,
            minWidth: { sm: cardWidth },
            maxWidth: { sm: cardWidth },
          },
        }}
      >
        {children}
      </Stack>
    </Box>
  );
}
